import AuthForm from '../../components/Auth/AuthForm';
import ImageSlider from '../../components/imageSlider/ImageSlider';
import classes from './AuthPage.module.css'
import LanguageSwitcher from '../../components/ui/LanguageSwitcher/LanguageSwitcher';
import { appLogoPath, company } from '../../components/config/variables';

const AuthPage = () => {
  return (
    <div className={classes.container}>
      <div className={classes.cover}>
        <div className={classes.header}>
          <div className={classes.image}>
            <img src={appLogoPath} alt="logo" className={classes[company]} />
          </div>
          <div className={classes.langIcon}>
            <LanguageSwitcher customStyle={{}} />
          </div>
        </div>
        <div className={classes.form}>
          <AuthForm />
        </div>
      </div>
      <div className={classes.slider}>

      <ImageSlider />
      </div>
    </div>
    );
};

export default AuthPage;
